<template>
  <div
    class="sky__saved-filters-wrapper "
    :class="{
      'needs-arrows': needsArrows,
      'needs-arrow-left': scrollLeft > 0
    }"
  >
    <div v-if="scrollLeft > 0" class="arrow-left-btn" @click="$refs.scroller.scrollTo({left: 0, behavior: 'smooth'})">
      <div class="p-3 bg-red-400 rounded-full shadow" style="position: relative; left: 7px; background: rgba(256,256,256, 0.95)">
        <icon-select-down class="sky__icon-arrow-right" style="transform: rotate(90deg);" />
      </div>
    </div>
    <div ref="scroller" class="sky__scroller">
      <div
        v-for="savedFilter in category.facetGroups.filter(f => f.cover)"
        :key="savedFilter.id"
        class="flex justify-start items-center rounded cursor-pointer select-none rounded-full mx-2"
        :class="isFilterUsed(savedFilter.payload) ? 'bg-sky_blue' : 'bg-sky_grey_darker'"
        @click="isFilterUsed(savedFilter.payload) ? $emit('cancel') : addFilter(savedFilter)"
      >
        <div class="px-1" style="width: 42px;">
          <img style="width: 35px" class="rounded-full" :src="`${savedFilter.cover}?resize=true&width=70`" alt="Cover">
        </div>
        <div
          class="text-center rounded-r-full pl-1 pr-3 flex items-center font-bold"
          :class="isFilterUsed(savedFilter.payload) ? 'text-white' : ''"
          style="white-space: nowrap; font-size:0.80rem"
        >
          {{ savedFilter.label }}
        </div>
      </div>
    </div>
    <div v-if="needsArrows && scrollRight" class="arrow-right-btn" @click="arrowRightClicked">
      <div class="p-3 bg-red-400 rounded-full shadow" style="position: relative; left: -15px; background: rgba(256,256,256, 0.95)">
        <icon-select-down class="sky__icon-arrow-right" style="transform: rotate(-90deg);" />
      </div>
    </div>
  </div>
</template>

<script>
import omit from 'lodash.omit'
export default {
  props: {
    category: {
      required: true,
      type: Object
    },
    filter: {
      required: true,
      type: Array
    }
  },
  data () {
    return {
      needsArrows: false,
      needsArrowLeft: false,
      scrollLeft: 0,
      scrollRight: 0
    }
  },
  watch: {
    '$store.state.screen.width' () {
      this.checkArrows()
      this.scrollRight = this.$refs.scroller.scrollWidth - (this.$refs.scroller.scrollLeft + this.$refs.scroller.clientWidth)
    }
  },
  mounted () {
    this.checkArrows()
    this.scrollRight = this.$refs.scroller.scrollWidth - (this.$refs.scroller.scrollLeft + this.$refs.scroller.clientWidth)
    this.$refs.scroller.onscroll = () => {
      this.scrollLeft = this.$refs.scroller.scrollLeft
      this.scrollRight = this.$refs.scroller.scrollWidth - (this.$refs.scroller.scrollLeft + this.$refs.scroller.clientWidth)
    }
  },
  methods: {
    addFilter (filter) {
      this.$emit('add-filter', filter.payload.map(i => omit(i, ['feature_name'])))
      this.$gtmEvents.onActivatedFacetGroup(this.category, filter.label)
    },
    isFilterUsed (payload) {
      return JSON.stringify(this.filter.filter(f => f?.values?.length)) === JSON.stringify(payload.map(i => omit(i, ['feature_name'])))
    },
    checkArrows () {
      if (this.$refs.scroller.scrollWidth !== this.$refs.scroller.clientWidth) {
        this.needsArrows = true
        return
      }
      this.needsArrows = false
    },
    arrowRightClicked () {
      const elements = Array.from(this.$refs.scroller.children)
      const currentScroll = this.$refs.scroller.scrollLeft
      const offsets = elements.map(el => el.offsetLeft)
      const reversedOffsets = JSON.parse(JSON.stringify(offsets)).reverse()
      const corresponding = reversedOffsets.find(w => w - 30 <= currentScroll)
      const correspondingIndex = offsets.indexOf(corresponding)
      const nextScroll = offsets[correspondingIndex + 1]
      if (nextScroll) {
        this.$refs.scroller.scrollTo({
          left: nextScroll - 30,
          top: 0,
          behavior: 'smooth'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.sky__icon-arrow-right {
  width: 10px;
  @apply text-sky_secondary;
  path {
    stroke: currentColor;
    fill: transparent;
  }
}
.sky__saved-filters-wrapper {
  overflow-y: hidden;
  position: relative;
  @apply absolute top-0 left-0 right-0 bottom-0;
  &.needs-arrows {
    // padding-right: 30px;
    .arrow-right-btn {
      @apply cursor-pointer hidden items-center justify-center;
      @screen lg {
        @apply flex;
      }
      width: 30px;
      position: absolute;
      top: -1px;
      bottom: -1px;
      right: -1px;
      background: white;
    }
  }
  &.needs-arrow-left {
    // padding-left: 30px;
    .arrow-left-btn {
      @apply cursor-pointer hidden items-center justify-center;
      @screen lg {
        @apply flex;
      }
      width: 30px;
      position: absolute;
      top: 0;
      bottom: -1px;
      left: -1px;
    }
  }
  .sky__scroller {
    max-width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    @apply flex;
    height: 100%;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
    &::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>
